import {
    GET_ALL_ASHRAMWASI_USERS,
    CREATE_DEPARTMENT,
    CREATE_ISSUE_CATEGORY,
    CREATE_ROOM_LOCATION,
    DELETE_ISSUE_CATEGORY,
    DELETE_ROOM_LOCATION,
    GET_ALL_DEPARTMENTS,
    GET_ISSUE_CATEGORY,
    GET_ROOM_LOCATION,
    UPDATE_DEPARTMENT,
    UPDATE_ISSUE_CATEGORY,
    UPDATE_ROOM_LOCATION,
    UPDATE_USER,
    ADD_USER,
    GET_SOS_LIST,
    UPDATE_USER_STATUS,
} from "shared/constants/ActionTypes";
const initialState = {
    allAshramwasiUsers: [],
    allDepartmentList: [],
    issueCategoryList: [],
    roomLocationList: [],
    sosList: [],
};
export const masterReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ALL_ASHRAMWASI_USERS:
            return {
                ...state,
                allAshramwasiUsers: action.payload,
            };

        case ADD_USER:
            return {
                ...state,
                allAshramwasiUsers: [
                    action.payload,
                    ...state.allAshramwasiUsers,
                ],
            };
        case UPDATE_USER:
            return {
                ...state,
                allAshramwasiUsers: state.allAshramwasiUsers.map((item) =>
                    item.id === action.payload.id ? { ...action.payload } : item
                ),
            };

        case UPDATE_USER_STATUS:
            return {
                ...state,
                allAshramwasiUsers: [
                    ...state.allAshramwasiUsers.map((item) => {
                        if (item.id === action.payload.id) {
                            return { ...item, status: action.payload.status };
                        } else {
                            return item;
                        }
                    }),
                ],
            };
        // DEPARTMENT MASTER
        case GET_ALL_DEPARTMENTS:
            return {
                ...state,
                allDepartmentList: action.payload,
            };
        case CREATE_DEPARTMENT:
            return {
                ...state,
                allDepartmentList: [action.payload, ...state.allDepartmentList],
            };
        case UPDATE_DEPARTMENT:
            return {
                ...state,
                allDepartmentList: [
                    ...state.allDepartmentList.map((item) =>
                        item.id === action.payload.id
                            ? { ...action.payload.data }
                            : item
                    ),
                ],
            };
        // ISSUE CATEGORY MASTER
        case GET_ISSUE_CATEGORY:
            return {
                ...state,
                issueCategoryList: action.payload,
            };
        case CREATE_ISSUE_CATEGORY:
            return {
                ...state,
                issueCategoryList: [action.payload, ...state.issueCategoryList],
            };
        case UPDATE_ISSUE_CATEGORY:
            return {
                ...state,
                issueCategoryList: [
                    ...state.issueCategoryList.map((item) =>
                        item.id === action.payload.id
                            ? { ...action.payload.data }
                            : item
                    ),
                ],
            };
        case DELETE_ISSUE_CATEGORY:
            return {
                ...state,
                issueCategoryList: state.issueCategoryList.filter(
                    (el) => el.id !== action.payload.id
                ),
            };

        // LOCATION AUTHORITIES MASTER
        case GET_ROOM_LOCATION:
            return {
                ...state,
                roomLocationList: action.payload,
            };
        case CREATE_ROOM_LOCATION:
            return {
                ...state,
                roomLocationList: [action.payload, ...state.roomLocationList],
            };
        case DELETE_ROOM_LOCATION:
            return {
                ...state,
                roomLocationList: state.roomLocationList.filter(
                    (el) => el.id !== action.payload.id
                ),
            };
        case UPDATE_ROOM_LOCATION:
            return {
                ...state,
                roomLocationList: [
                    ...state.roomLocationList.map((item) =>
                        item.id === action.payload.id
                            ? { ...action.payload.data }
                            : item
                    ),
                ],
            };
        case GET_SOS_LIST:
            return {
                ...state,
                sosList: action.payload.data,
            };
        default:
            return state;
    }
};
